<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Preguntas"   />

    <QuestionsComponent :play="play" :getPlayConfig="getPlayConfig"  @update:playItems="updated => play.items = updated" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import QuestionsComponent from "@/components/Pages/Admin/Questions/index.vue";
import api from '@/services/api'; 
import { useRoute } from 'vue-router' 

export default defineComponent({
  name: "QuestionsPage",
  components: {
    PageTitle,
    QuestionsComponent,
  },
  setup() {
    const route = useRoute();
    const isLoading = ref(false);
    const play = ref<any>({});

    onMounted(async () => {
      var idPlay = route.params.id ;
      if(idPlay){
        await getPlayConfig(idPlay);
      }

    });
    const getPlayConfig= async(id: any) => {
      try {
        isLoading.value = true; 

        const response = await api.get(`/play/${id}/config`);
        play.value = response.data 

      } catch (error) {
        console.error(error);
      }finally{
        isLoading.value = false;
      }
    };

    return {
      play, 
      isLoading, 
      getPlayConfig
    };
  }
  
});
</script>
